import { Navigate, useLocation } from 'react-router-dom';
import { type ReactNode } from 'react';
import { useAuth } from './AuthContext';
import { isEmailAuthorized } from './authorizedAccounts';

export function RequireAuth({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-nm-muted">
        Checking session...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!isEmailAuthorized(user.email)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <>{children}</>;
}
